export enum AppMode {
  Desktop = 'desktop',
  Mobile = 'mobile',
}
